import { DataConverter } from "../../Global/Base/Converters/DataConverter";
import { createElement, registerCustomElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { Control } from "./Control";
import { EditableControl } from "./EditableControl";

export class ColorEdit extends EditableControl {
    protected override _innerElement: HTMLInputElement;

    private _originalValue: string;
    private _swatchClickListener: EventListener;

    //#region Properties
    public override set value(val: any) {
        this.controlValue = val;
    }

    public override get value(): any {
        return this.controlValue;
    }

    public get controlValue(): string {
        return this._originalValue;
    }

    /**
     * Nastavi hodnotu editu
     */
    public set controlValue(value: string) {
        if (value) {
            this._innerElement.value = value;
        } else {
            this._innerElement.value = "#000000"; // Defaultní hodnota dle standardu. Nepoužívá se null, aby se v konzoli nezobrazovaly chyby
        }

        this._originalValue = value;

        this.classList.toggle("Empty", (value == null)); // Umožňuje zobrazit transparentní prvek u prázdné hodnoty
    }

    //#endregion Properties
    protected override _constructor(): void {
        super._constructor();

        this.innerHTML = "";

        this._innerElement = createElement({ type: "input", attrs: { "type": "color" } }) as HTMLInputElement;

        this.classList.add("ColorEdit", "Empty");
        this.appendChild(this._innerElement);
    }

    protected override connectedCallback(): void {
        super.connectedCallback();

        if (this._innerElement) {
            Control.registerEventListener(this._eventGroup, this._innerElement, "change", (e) => {
                e.stopPropagation();

                this.controlValue = this._innerElement.value;

                this.callEvent("change");
            });

            this.addEventListener("click", this._swatchClickListener = (_event) => {
                if (this._originalValue == null) {
                    // Získáme aktuální barvu EC podle tématu a tu nastavíme jako default
                    this.controlValue = DataConverter.rgbToHex(window.getComputedStyle(this).backgroundColor);
                }
            });
        }
    }

    //destruktor
    public override dispose(): void {
        this.removeEventListener("click", this._swatchClickListener);

        super.dispose();
    }
}

registerCustomElement("tsc-coloredit", ColorEdit);
